import React from 'react'
import { PLAN_TYPES, PLAN_FEATURES, PLAN_COMPARISON, getCurrentPlan, setPlan } from '../config/planConfig'

const PlanComparison = ({ showSwitcher = true, embedded = false, onPlanChange = null }) => {
  const [currentPlan, setCurrentPlan] = React.useState(getCurrentPlan())

  const handlePlanChange = (planType) => {
    if (window.confirm(`${PLAN_FEATURES[planType].name}に切り替えますか？`)) {
      const success = setPlan(planType)
      if (success) {
        setCurrentPlan(planType)
        // 親コンポーネントに通知
        if (onPlanChange) {
          onPlanChange(planType)
        }
      }
    }
  }

  const containerStyle = embedded ? {
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    margin: '20px 0'
  } : {
    padding: '40px',
    maxWidth: '1200px',
    margin: '0 auto'
  }

  return (
    <div className="container-responsive" style={containerStyle}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h2 className="text-responsive-2xl" style={{ 
          color: '#333', 
          marginBottom: '10px'
        }}>
          🏮 AI受付システム 松・竹・梅プラン比較
        </h2>
        <p className="text-responsive-base" style={{ color: '#666' }}>
          現在のプラン: <strong style={{ color: PLAN_FEATURES[currentPlan].color }}>
            {PLAN_FEATURES[currentPlan].name}
          </strong>
        </p>
      </div>

      {/* プランカード */}
      <div className={embedded ? "grid-responsive" : "plan-grid"} style={{
        marginBottom: '40px'
      }}>
        {Object.entries(PLAN_FEATURES).map(([planType, plan]) => (
          <div
            key={planType}
            style={{
              border: currentPlan === planType ? `3px solid ${plan.color}` : '2px solid #ddd',
              borderRadius: '12px',
              padding: '24px',
              backgroundColor: currentPlan === planType ? plan.color + '10' : 'white',
              position: 'relative',
              transition: 'all 0.3s ease'
            }}
          >
            {currentPlan === planType && (
              <div style={{
                position: 'absolute',
                top: '-10px',
                right: '20px',
                backgroundColor: plan.color,
                color: 'white',
                padding: '4px 12px',
                borderRadius: '12px',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
                現在のプラン
              </div>
            )}
            
            <div style={{ textAlign: 'center', marginBottom: '16px' }}>
              <h3 style={{ 
                color: plan.color, 
                margin: '0 0 8px 0',
                fontSize: '24px',
                fontWeight: 'bold'
              }}>
                {plan.name}
              </h3>
              <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
                {plan.description}
              </p>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <div style={{
                backgroundColor: plan.color + '20',
                padding: '12px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', color: plan.color }}>
                  アバターグレード
                </div>
                <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#333', marginBottom: '4px' }}>
                  {plan.avatarGrade}
                </div>
                <div style={{ fontSize: '12px', color: '#666' }}>
                  {plan.avatarDescription}
                </div>
              </div>
            </div>

            {showSwitcher && currentPlan !== planType && (
              <button
                className="btn-responsive"
                onClick={() => handlePlanChange(planType)}
                style={{
                  backgroundColor: plan.color,
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'opacity 0.3s ease',
                  width: '100%'
                }}
                onMouseOver={(e) => e.target.style.opacity = '0.8'}
                onMouseOut={(e) => e.target.style.opacity = '1'}
              >
                {plan.name}に切り替え
              </button>
            )}
          </div>
        ))}
      </div>

      {/* 機能比較表 */}
      <div className="card-responsive">
        <h3 className="text-responsive-xl" style={{ 
          textAlign: 'center', 
          marginBottom: '24px',
          color: '#333'
        }}>
          📊 機能比較表
        </h3>
        
        <div className="table-responsive">
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse',
            fontSize: '14px'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'left', 
                  borderBottom: '2px solid #dee2e6',
                  fontWeight: 'bold'
                }}>
                  機能項目
                </th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  borderBottom: '2px solid #dee2e6',
                  color: PLAN_FEATURES[PLAN_TYPES.UME].color,
                  fontWeight: 'bold'
                }}>
                  梅プラン
                </th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  borderBottom: '2px solid #dee2e6',
                  color: PLAN_FEATURES[PLAN_TYPES.TAKE].color,
                  fontWeight: 'bold'
                }}>
                  竹プラン
                </th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  borderBottom: '2px solid #dee2e6',
                  color: PLAN_FEATURES[PLAN_TYPES.MATSU].color,
                  fontWeight: 'bold'
                }}>
                  松プラン
                </th>
              </tr>
            </thead>
            <tbody>
              {PLAN_COMPARISON.map((row, index) => (
                <tr key={index} style={{
                  backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
                }}>
                  <td style={{ 
                    padding: '12px', 
                    borderBottom: '1px solid #dee2e6',
                    fontWeight: '500'
                  }}>
                    {row.feature}
                  </td>
                  <td style={{ 
                    padding: '12px', 
                    textAlign: 'center', 
                    borderBottom: '1px solid #dee2e6'
                  }}>
                    {typeof row.ume === 'boolean' ? (
                      <span style={{ 
                        fontSize: '18px',
                        color: row.ume ? '#28a745' : '#dc3545'
                      }}>
                        {row.ume ? '✓' : '×'}
                      </span>
                    ) : (
                      <span style={{ fontWeight: 'bold', color: PLAN_FEATURES[PLAN_TYPES.UME].color }}>
                        {row.ume}
                      </span>
                    )}
                  </td>
                  <td style={{ 
                    padding: '12px', 
                    textAlign: 'center', 
                    borderBottom: '1px solid #dee2e6'
                  }}>
                    {typeof row.take === 'boolean' ? (
                      <span style={{ 
                        fontSize: '18px',
                        color: row.take ? '#28a745' : '#dc3545'
                      }}>
                        {row.take ? '✓' : '×'}
                      </span>
                    ) : (
                      <span style={{ fontWeight: 'bold', color: PLAN_FEATURES[PLAN_TYPES.TAKE].color }}>
                        {row.take}
                      </span>
                    )}
                  </td>
                  <td style={{ 
                    padding: '12px', 
                    textAlign: 'center', 
                    borderBottom: '1px solid #dee2e6'
                  }}>
                    {typeof row.matsu === 'boolean' ? (
                      <span style={{ 
                        fontSize: '18px',
                        color: row.matsu ? '#28a745' : '#dc3545'
                      }}>
                        {row.matsu ? '✓' : '×'}
                      </span>
                    ) : (
                      <span style={{ fontWeight: 'bold', color: PLAN_FEATURES[PLAN_TYPES.MATSU].color }}>
                        {row.matsu}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* プラン説明 */}
      <div style={{ 
        marginTop: '30px', 
        padding: '20px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '8px' 
      }}>
        <h4 style={{ color: '#333', marginBottom: '16px' }}>各プランの詳細</h4>
        <div style={{ display: 'grid', gap: '12px', fontSize: '14px', color: '#666' }}>
          <div><strong>梅プラン：</strong>音声受付・通知中心の基本AI受付体験</div>
          <div><strong>竹プラン：</strong>地図案内やアバター動作など、視覚ナビを備えた拡張版</div>
          <div><strong>松プラン：</strong>顔認証・自然対話・アバター変更など、高度AI応対を搭載した最上位プラン</div>
        </div>
      </div>
    </div>
  )
}

export default PlanComparison